<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import { tv } from '../tv';

	export const overlayCenterVariants = tv({
		base: 'flex h-full items-center justify-center'
	});

	export interface OverlayCenterProps extends Omit<HTMLAttributes<HTMLElement>, 'class'> {
		as?: string;
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'div',
		children,
		class: className,
		ref = $bindable(null),
		...rest
	}: OverlayCenterProps = $props();
</script>

<svelte:element this={as} bind:this={ref} class={[overlayCenterVariants(), className]} {...rest}>
	{@render children?.()}
</svelte:element>
